// Ie8 Font fix
var errorcallback = window.errorcallback || function fallbackErrorCallback(e) {
	if (window.console && typeof window.console.error === 'function') {
		window.console.error(e);
	}
	return true;
};

$(document).ready(function() {
	'use strict';
	var $style = $('<style type="text/css">:before,:after{content:none !important}</style>');
	$('head').append($style);
	return setTimeout((function() {
		return $style.remove();
	}), 0);
});

+function ($) {
	'use strict';
	try {
		 $('[data-toggle="tooltip"]').tooltip();

		// enable ajax caching
		$.ajaxSetup({
			cache: true,
			async: true
		});

		$(document).ajaxStart(function () {
			$('html').addClass('cursor-wait');
		}).ajaxComplete(function () {
			$('html').removeClass('cursor-wait');
		});

		$.delay = (function() {
			var timer = {};
			return function(callback, ms, queue) {
				clearTimeout (timer[queue]);
				timer[queue] = setTimeout(callback, ms);
			};
		})();
	} catch (e) {errorcallback(e);}

	try {
		// Menu
		$('#menu-toggle').click(function(e) {
			e.preventDefault();
			$('#wrapper').toggleClass('active');
		});

		// Toggles [yes/no fields]
		$('.toggle').each(function() {
			$(this).toggles({
				on: $($(this).data('checkbox')).is(':checked'),
				checkbox: $(this).data('checkbox'),
				text: {
					on: $(this).data('ontext'),
					off: $(this).data('offtext')
				},
				transition: 'ease-out'
			});

			var thisSlider = $(this);
			$(thisSlider.data('checkbox')).change(function() {
				thisSlider.toggles($(this).is(':checked'));
			});
		});

		$('.toggle').click(function() {
			$($(this).data('checkbox')).change();
		});



	} catch (e) {errorcallback(e);}

	// Validate forms
	try {
		if ($('.form-validate').length>0) {

			// sort dropdowns [should have sort class, but that's not there yet]
			$('select.sort,select#attr_currency_of_lease_agreement,select#attr_currency,select#attr_country,select#attr_vendor,select#attr_asset_type,select#attr_decline_id').sortdropdown();

			jQuery.validator.addClassRules('field_email', {email: true});
			jQuery.validator.addClassRules('field_number', {number: true});
			jQuery.validator.addClassRules('field_url', {url: true});
			jQuery.validator.addClassRules('field_digit', {digits: true});
			jQuery.validator.addClassRules('field_integer', {digits: true});
			jQuery.validator.addClassRules('field_basispoint', {digits: true});

			//add custom date range validation method
			jQuery.validator.addMethod("dateRange", function(valueDate,element) {
			   try{
					var parsedDate = moment(valueDate, date_format, true);
					if (!parsedDate.isValid()) {
						return false;
					}
					var valueDate = parsedDate.toDate();
			   } catch (e) {return false}//if not valid date validation is false


				var checkDateMin = new Date();
				//min date range is now minus 30 years
				checkDateMin.setFullYear( checkDateMin.getFullYear() - 30 );
				var checkDateMax = new Date();
				//maxdate range is now plus 30 years
				checkDateMax.setFullYear( checkDateMax.getFullYear() + 30 );
				if(( valueDate < checkDateMin ) || ( valueDate > checkDateMax ))
					return false;

				return true;
			}, "Please specify a correct date:");

			jQuery.validator.addClassRules('field_date', {dateRange:true});

			fixSpecialFields();

			$('.form-validate').validate({
				rules: {
					password1: {
						required: true,
						minlength: 8
					},
					password2: {
						equalTo: '#password1'
					},
					attr_term_in_months: {
						'term_grace_leasing':($('input[name=attr_type]').val()==='leasing'),
						'max_term_leasing':($('input[name=attr_type]').val()==='leasing'),
						'max_term_factoring':($('input[name=attr_type]').val()==='factoring')},
					attr_net_principal_amount: 'net_principal_amount',
					attr_grace_holiday_period: 'grace_holiday_period',
					attr_credit_limit: 'credit_limit',
                    attr_residual_value: 'residual_value',
                    attr_expected_residual_value: 'residual_value',
				},
				ignore: ":hidden:not(.active .do-validate)",
				errorPlacement: function(error, element) {
					error.insertBefore(element.parent());
				},
				highlight: function(element) {
					$(element).closest('.input-group').addClass('error');
					$(element).closest('.accordion-panel').addClass('panel-error');
				},
				unhighlight: function(element) {
					$(element).closest('.input-group').removeClass('error');
					var $accordion_panel = $(element).closest('.accordion-panel');
					if ($accordion_panel.length > 0) {
						if ($accordion_panel.find('.input-group.error').length === 0) {
							$accordion_panel.removeClass('panel-error');
						}
					}
				},
				onfocusout: function() {  }
			});
		}

		$('.field_date:not([readonly]),.field_datetime:not([readonly])').each(function() {
			makeDatePicker($(this));
		});

	} catch (e) {errorcallback(e);}

	try {
		// tables
		fixTables();

		$('.helptext').tooltip({html:true});

		$('[data-toggle="tooltip"]').tooltip();

		// Ping after 5 minutes
		window.setTimeout(ping,300000);
	} catch (e) {errorcallback(e);}

    // refresh list of approvers if user has applied changes
    try {
        $('#wizard form').each(function(){
            $(this).data('serialized',JSON.stringify($(this).serializeObject()));
        });
    } catch (e) {errorcallback(e);}

}(jQuery);

window.makeDatePicker = makeDatePicker;
window.fixSpecialFields = fixSpecialFields;
window.setFieldDefault = setFieldDefault;
window.hideFields = hideFields;
window.showFields = showFields;
window.fixTables = fixTables;
window.checkChangedFields = checkChangedFields;
window.showMessage = showMessage;
window.getMessageIcon = getMessageIcon;
window.getUnmaskedValue = getUnmaskedValue;
window.countChar = countChar;
window.validateWizardStep = validateWizardStep;

function validateWizardStep(activeToggle) {
	'use strict';
	var $form = $('#wizard form');
	if ($form.length===0) {
		return true;
	}

	var validator = $form.data('validator');
	if (!validator) {
		return $form.valid();
	}

	var targetSelector = $(activeToggle).attr('href');
	var $pane = targetSelector ? $(targetSelector) : $('#wizard .tab-pane.active');
	var isValid = true;

	$pane.find(':input').each(function() {
		var $field = $(this);
		var $row = $field.closest('.formrow');
		if (
			$field.is(':hidden') ||
			$field.is('[disabled]') ||
			($row.length > 0 && !$row.is(':visible'))
		) {
			return;
		}
		if (!validator.element(this)) {
			isValid = false;
		}
	});

	return isValid;
}

function makeDatePicker($this) {
	'use strict';
	try {
		$this.datetimepicker({
			icons: {
				time: 'fa fa-clock-o',
				date: 'fa fa-calendar',
				up: 'fa fa-arrow-up',
				down: 'fa fa-arrow-down',
				previous: 'fa fa-arrow-left',
				next: 'fa fa-arrow-right'
			},
			format:$this.hasClass('field_datetime') ? date_format+' HH:mm' : date_format,
			minDate: $this.data('startdate') ? $this.data('startdate') : false,
			maxDate: $this.data('enddate') ? $this.data('enddate') : false,
		});
	} catch (e) { errorcallback(e);}
}

// Some fields need some special attention, fix them here
function fixSpecialFields() {
	'use strict';
	try {
		/* Valuta masking */
		$('.field_valuta').inputmask('decimal', { radixPoint: '.', autoGroup: true, groupSeparator: ',', groupSize: 3, rightAlign: false });

	} catch (e) {errorcallback(e);}

}


function setFieldDefault(name,value,changeValue) {
	'use strict';
	if ($('input#attr_'+name).length===1) {
		if(changeValue) {$('input#attr_'+name).val(value);}
		var label = $("label[for='attr_"+name+"']");
		// remove old helptext
		$('small',label).remove();
		// add new
		$('<small> [Default: '+value+']</small>').appendTo(label);
	}
}
function hideFields(fields) {
	'use strict';
	$.each(fields, function(key,field) {
		var $field = $('#attr_'+field);
		var $row = $field.closest('.formrow');
		($row.length ? $row : $field.parent().parent()).hide();
	});
}
function showFields(fields) {
	'use strict';
	$.each(fields, function(key,field) {
		var $field = $('#attr_'+field);
		var $row = $field.closest('.formrow');
		($row.length ? $row : $field.parent().parent()).show();
	});
}

// Fix tables [enables datatable]
function fixTables() {
	'use strict';
	try {
		if ($('table.dataTable:not(.gotDatatable)').length>0) {
			//check if checkbox rowselect present in table, if so set initial sorting index to next column
			var initialSort=0;
			var order = 'asc';

			if($('table.dataTable:not(.gotDatatable)').find('th.rowselect').length){
				initialSort=1;
			}
			// If first column is Deal id set initialSort to DESC
			if ($('.table>thead:first-child>tr:first-child>th:first-child:contains("Deal ID")').length) {
				order = 'desc';
			}
			var $table = $('table.dataTable:not(.gotDatatable)');
			var options = {
				bStateSave: true,
				autoWidth: false,
				iDisplayLength: 10,
				order:[[initialSort,order]],
				fnRowCallback: function( nRow, aData, iDisplayIndex ) {
				if($(nRow).find('input[name*=contract_selected]:checked').length)
					$(nRow).addClass('contract_selected');//selected rows class
			  }
			};
			var ajaxtable = $table.data('ajaxtable');
			if (ajaxtable) {
				//options.processing = true;
				options.serverSide = true;
				options.ajax = {url:ajaxtable,type: 'POST'};
				var rowclick = $table.data('rowclick');
			}

			$table.dataTable(options).addClass('gotDatatable');

			// Column search
			$table.DataTable().columns().every( function () {
				var that = this;
				var s = that.search();
				if (s) $('input',this.header()).val(s);
				$('input',this.header()).on('keyup change', function () {
					var old = that.search();
					var val = $(this).val();
					// Delay the search, so we won't get too much ajax request while still typing
					if(old!==val) $.delay(function(){
						that.search(val).draw();
					}, 200,'search');
				}).on('click',function(event){
					event.stopPropagation();
				});
			});

			// Toggle filter fields
			$('a[data-columnfilter]').click(function(){
				if ($(this).data('columnfilter')=='show') {
					$('a[data-columnfilter="show"]').hide();
					$('a[data-columnfilter="hide"]').show();
					$('thead input',$table).show();
				} else {
					$('a[data-columnfilter="hide"]').hide();
					$('a[data-columnfilter="show"]').show();
					$('thead input',$table).val('').change().hide();
				}
			});

			// Clear old searchresults when filters are hidden
			if($('a[data-columnfilter="show"]').is(':visible')) {
				$('thead input',$table).val('').change();
			}

			if ($table.data('sort')) {
				var sort = $table.data('sort');
				sort = sort.split('.');
				$table.DataTable().order([sort[0],sort[1]]).draw();
			}

			$('#dataTables_filter input').bind('keyup', function() {
				var val = $(this).val();
				// Delay the search, so we won't get too much ajax request while still typing
				$.delay(function(){
					$('table.dataTable.gotDatatable').each(function( index ) {
						var old = $(this).DataTable().search();
						// No need to research when nothing has changed (like cursor movements)
						if (old !== val) {
							$(this).DataTable().search(
								val,
								false, // regex
								true // smart
							).draw();
						}
					});
				}, 200,'search');
			});

			$('#dataTables_filter i').click(function(){
				$('#dataTables_filter input').val('').keyup();
			});

			var sSearch = $('table.dataTable.gotDatatable').first().DataTable().search();
			$('#dataTables_filter input').val(sSearch);

			$('.btn[data-export]').click(function(){
				var params = $table.DataTable().ajax.params();
				$.ajaxDownload($(this).attr('href'),params);
				return false;


				//todo: export should also get filter!
				var search = $('#dataTables_filter input').val();
				if (!search) return true;
				var href = $(this).attr('href');
				href += (href.split('?')[1] ? '&':'?') + 'search='+search;
				window.location.href = href;
				return false;
			});

			if (ajaxtable && rowclick) {
				$('table.dataTable.gotDatatable').on('click','tr',function(){
					// Get id, and remove id_
					if (this.id.substring(0,3) != 'id_') return false;
					var id = this.id.substring(3);
					window.location.href = rowclick.replace('[id]',id);
					return false;
				});
			}
		}

		$('a[data-timefilter]').click(function(){
			var queryParams = $.getQueryParameters();
			queryParams['timefilter'] = $(this).data('timefilter');
			window.location.href = '?'+$.param(queryParams);
			return false;
		});

	} catch (e) {errorcallback(e);}
}

// Wizard
+function ($) {
	'use strict';
	try {
		// Generate the wizard
		if ($('#wizard').length>0) {

			var readonly = $('#wizard').data('readonly');

			// Add a unique order to each tab
			$('#wizard ul.nav li a').each(function( index ) {
				$(this).data('wizardorder',index);
				if (readonly) {
					$(this).parent().removeClass('disabled');
				} else {
					if (index>0) {$(this).parent().addClass('disabled');}
				}
			});
			// next button
			if (!window.__bootstrapLegacyBridgeActive) {
				$('#wizard ul.pager .next a').click(function (e) {
					e.preventDefault();
					var tmp = $('#wizard ul.nav li.active').nextAll(':visible').first().find('a').click();

				});
				// prev button
				$('#wizard ul.pager .previous a').click(function (e) {
					e.preventDefault();
					var tmp = $('#wizard ul.nav li.active').prevAll(':visible').first().find('a').click();
				});
			}
			// finish button
			$('#wizard ul.pager .finish a').click(function (e) {
				e.preventDefault();
				if ($('#wizard form').length>0 && validateWizardStep($('#wizard ul.nav li.active a')[0])) {$('#wizard form').submit();}
			});
			// switch tab
			$(document).on('show.bs.tab', '#wizard ul.nav li a', function (e) {
				//var nextOrder = $(e.target).data('wizardorder'); // activated tab
				//var prevOrder = $(e.relatedTarget).data('wizardorder'); // previous tab
				var nextOrder = $('#wizard ul.nav li:visible a').index(e.target);
				var prevOrder = $('#wizard ul.nav li:visible a').index(e.relatedTarget);
				// next tab
				if (nextOrder==prevOrder+1) {
					if (!readonly) {
						if ($('#wizard form').length===0 || validateWizardStep(e.relatedTarget)) {
							var validatecallback = $(e.relatedTarget).data('validate');
							if (validatecallback && !window[validatecallback]()) {return false;}
							$(e.relatedTarget).addClass('pills-success');
							$(e.target).parent().removeClass('disabled');
						} else {
							e.preventDefault();
							return false;
						}
					}

				// skipping some steps
				} else if (nextOrder>prevOrder) {
					if (!readonly) {
						e.preventDefault();
						return false;
					}

				// going back
				} else if (nextOrder<prevOrder) {
					// need to find all skipped tabs
					$('#wizard ul.nav li a').each(function( index ) {
						if (index>nextOrder) {
							if (!readonly) {$(this).removeClass('pills-success').parent().addClass('disabled');}
						}
					});
				}

				var callback = $(e.target).data('callback');
				if (callback) {window[callback]();}
				return true;
			});

		}

		// Scroll to active
		$('#sidebar-wrapper ul.sidebar-nav').each(function(){
			var $this = $(this);
			var $elem = $this.find('li.active:first');
			if ($elem && $elem.offset() && $this.offset()) {
				var top = $this.scrollTop() - $this.offset().top + $elem.offset().top - $this.height() + ($elem.height()*5);
				if (top>0) $this.scrollTop(top);
			}
		});

	} catch (e) {errorcallback(e);}

}(jQuery);

function saveNoMatch(deal_id,contract_id) {
	bootbox.prompt('Comment', function(result) {
		if (result !== null && result !== '') {
			$.postGo({'comment':result,deal_id:deal_id,contract_id:contract_id},'/matchbookedcontracts/nomatch');
		}
	});
	return false;
}

function countChar($this) {
	'use strict';
	try {
		var val = $($this).val();
		var len = val.length;
		var max = $('#charNum').data('max');
		if (len > max) {
			$($this).val(val.substring(0, max));
			$('#charNum').text(0);
		} else {
			$('#charNum').text(max - len);
		}
	} catch (e) {errorcallback(e);}
}

function downloadFAQFile(upload_id) {
    $.ajaxDownload('/faq/downloadFile',upload_id);
    return false;
}

// auto ping
function ping() {
	'use strict';

	try {
		$.ajax({
			type: 'POST',
			url: '/ping',
			//data: {url:'ping'},
			dataType: 'json',
			cache:false,
			global: false, // disable the ajaxStart / ajaxStop
			success: function(data){
				try {
					if (data.href) {
						location.href = data.href;
						return;
					}
					if (data.notify) {
						$.notify({
							message: data.notify.message,
							title: data.notify.title+'<br>',
							icon: data.notify.icon
						},{
							type: data.notify.type,
							delay: 15000,
							animate: {
								enter: 'animated fadeInRight',
								exit: 'animated fadeOutRight'
							}
						});
					}
				} catch (e) {errorcallback(e);}

				// re-ping after 5 minutes
				window.setTimeout(ping,300000);
			},
			error: function (x, e){
				// re-ping after 5 minutes
				window.setTimeout(ping,300000);
			}
		});
	} catch (e) {errorcallback(e);}
}


function showBookingCheckDealsPopup(data_id,typekey,overviewtype){

     try{
        if($('#deals_list_modal_'+data_id+'_'+typekey+'_modal').length){
            $('#deals_list_modal_'+data_id+'_'+typekey+'_modal').modal('show');
        }else{
            var relevant_ids = $("#"+data_id+'_'+typekey).val();
            if(relevant_ids.length){
                $.ajax({
                    type: 'POST',
                    url: '/bookingchecks/bookingchecksmodal',
                    data: {
                        ids:relevant_ids,
                        data_id:data_id,
                        type:typekey,
                        overviewtype:overviewtype
                    },
                    dataType: 'html',
                    success: function(data){
                        try {
                            $('body').append(data);
                            $('#deals_list_modal_'+data_id+'_'+typekey+'_modal').modal('show');
                        } catch (e) {errorcallback(e);}
                    }
                });
            }
        }
    }catch (e) {errorcallback(e);}
}

/*
 * check if form has changed fields
 */
function checkChangedFields(callback) {
    var fieldsChanged = false;
    $('#wizard form').each(function () {
        if ($(this).data('serialized') != JSON.stringify($(this).serializeObject())) {
            fieldsChanged = true;
        }
    });

    if (fieldsChanged) {
        callback();
    } else {
    	return false;
	}

    return true;
}

function showMessage(identifier, type, content, header){
    var icon = getMessageIcon(type);
    var message = '<div id="'+identifier+'" class="alert alert-'+type+' alert-dismissable">';
    message += '<i class="fa '+icon+'"></i>';
    message += '<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>';
    message += '<strong>'+header+'</strong><br />';
    message += content;
    message += '</div>';

    $('#wrapper .container-fluid').prepend(message);
}


function getMessageIcon(type){
    if(type === 'warning') {
        return 'fa-exclamation-circle';
    } else if(type === 'success') {
        return 'fa-check-circle';
    } else if(type === 'danger') {
        return 'fa-times-circle';
    } else {
        return 'fa-info-circle';
    }
}

/*
 * Get unmasked value from a field masked with jquery inputmask plugin.
 * It returns regular value if not masked in inputmask.
 * @param $field jquery element
 * @param default_value value to return if field is empty
 */
function getUnmaskedValue($field, default_value) {
	var value = $field.val();
	if (value == '') {
		return default_value;
	}
	try {
		return $field.inputmask('unmaskedvalue');
	} catch (e) {}
	return value;
}
